import { render, staticRenderFns } from "./WhitePollutionPreventView.vue?vue&type=template&id=34233136&scoped=true&"
import script from "./WhitePollutionPreventView.vue?vue&type=script&lang=js&"
export * from "./WhitePollutionPreventView.vue?vue&type=script&lang=js&"
import style0 from "./WhitePollutionPreventView.vue?vue&type=style&index=0&id=34233136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34233136",
  null
  
)

export default component.exports